import { FileStorage } from '@frontend/auction/src/services/FileStorageService';
import { listenDialogsControls } from '@frontend/shared/src/utils/dialog';
import { PersistentAPIKey } from '@frontend/auction/src/helpers/PersistentAPIKey';
import { SPADialogSettingsWallpaper } from '@frontend/auction/src/components/spa-dialog-settings-wallpaper';
import { Wallpapers } from '@frontend/auction/src/services/WallpapersService';

export class SPADialogSettings extends HTMLDialogElement {
  constructor() {
    super();
  }

  connectedCallback() {
    listenDialogsControls('settings');

    this.initWallpapers();
    this.initApiKey();
  }

  initWallpapers = () => {
    const wallpapers = this.querySelector<HTMLDivElement>('.block.wallpapers .content')!;

    Wallpapers.wallpapers.forEach(wallpaper => {
      if (!wallpaper.src && wallpaper.file_id) {
        FileStorage.getBlobUrl(wallpaper.file_id).then(src => {
          if (src) {
            wallpaper.src = src;
          }
        });
      }
    });

    wallpapers.append(
      ...Wallpapers.wallpapers.map(wallpaper => {
        const element = new SPADialogSettingsWallpaper(wallpaper);

        return element;
      })
    );
  };

  initApiKey = () => {
    const input = this.querySelector<HTMLInputElement>('.block.api-key input')!;

    const apiKey = PersistentAPIKey.get();

    if (apiKey) {
      input.value = apiKey;
    }

    input.addEventListener('input', () => {
      PersistentAPIKey.set(input.value);
    });
  };
}

customElements.define('spa-dialog-settings', SPADialogSettings, { extends: 'dialog' });
